<div [ngStyle]="{'background-color': prevSectionColor}">
  <div class="footer-section pt-[40px] lg:pt-[100px] rounded-[30px] lg:rounded-[40px] ">
    <div class="text-center flex flex-col items-center justify-center">
      <span class="text-sm lg:text-md">Get inspired by our Instagram feed</span>
      @if (!isSmallScreen) {
        <h1><em>#my</em>&nbsp; <span class="font-semibold">XrossOverSports</span></h1>
      }
      @if (isSmallScreen) {
        <h2><em>#my</em>&nbsp; <span class="font-semibold">XrossOverSports</span></h2>
      }
    </div>
    <div class="py-4 overflow-x-hidden flex gap-[30px]">
      <xos-images-carousel [images]="footerImages"></xos-images-carousel>
    </div>
    <div class="pb-[20px] px-[16px] lg:p-[20px]">
      <div class="px-4 pt-[40px] pb-[20px] lg:p-[60px] footer">
        <div class="grid grid-cols-1 lg:grid-cols-5 pb-[40px]">
          <div class="lg:col-span-2 flex flex-col items-center lg:items-start gap-[20px]">
            <xos-company-logo appearance="white" [height]="59"></xos-company-logo>
            @if (!success) {
              <div>
                <div class="flex flex-col gap-2 text-center lg:text-left max-w-[340px] mx-auto lg:mx-0">
                  <h3 class="font-semibold">Join the XrossOver Movement</h3>
                  <p class="text-center lg:text-left text-white-80 text-sm">
                    Unlock 10% off your first order and get 3 months FREE with your personal AI Coach —
                    the training system built to help you become what you train to be.
                  </p>
                </div>
                <div class="mt-2 w-full flex flex-col items-center lg:items-start">
                  <div class="subscribe-input flex flex-row px-4 w-full max-w-[370px]">
                    <ng-container [formGroup]="formGroup">
                      <input type="email" formControlName="email" placeholder="Enter your email"
                        class="subscribe-input-field text-sm flex-grow">
                      <button
                        class="subscribe-input-button text-sm text-primary-100 transition flex justify-center items-center gap-2"
                        (click)="subscribe()">
                        @if (isLoading) {
                          <svg class="animate-spin h-5 w-5 text-white"
                            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                            stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor"
                            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                          </svg>
                        }
                        <span>
                          {{ isLoading ? 'Subscribing...' : 'Join & Get My Code' }}
                        </span>
                      </button>
                    </ng-container>
                  </div>
                  @if (this.formGroup.invalid && this.formGroup.touched) {
                    <div
                      class="text-red-80 text-sm mt-2">
                      Please enter a valid email address
                    </div>
                  }
                  @if (errorMessage) {
                    <div class="text-red-80 text-sm mt-2">
                      {{ errorMessage }}
                    </div>
                  }
                </div>
              </div>
            }
            @if (success) {
              <div
                class="flex flex-col gap-2 text-center lg:text-left max-w-[340px] mx-auto lg:mx-0">
                <h4 class="font-bold mb-2 text-green-600">Thanks for subscribing!</h4>
                <h5 class="font-bold mb-2">Welcome to the XrossOver Family!</h5>
                <p class="text-center lg:text-left text-white-80 text-sm">
                  Your exclusive discount code and free month access are on their way to your inbox —
                  please give it a few
                  minutes to arrive.
                </p>
              </div>
            }
          </div>
          @if (!isSmallScreen) {
            <ng-container *ngTemplateOutlet="servicesTemplate"></ng-container>
            <ng-container *ngTemplateOutlet="companyTemplate"></ng-container>
            <ng-container *ngTemplateOutlet="getInTouchTemplate"></ng-container>
          }
          @if (isSmallScreen) {
            <ng-container>
              <div class="flex flex-row items-center justify-between cursor-pointer py-3"
                (click)="toggleSection(footerSections.SERVICES)">
                <span>Services</span>
                <i-tabler
                  [name]="activeSection === footerSections.SERVICES ? 'chevron-up' : 'chevron-down'"
                  class="text-white-60">
                </i-tabler>
              </div>
              <div class="pt-2 accordion-content"
                [class.expanded]="activeSection === footerSections.SERVICES"
                [class.collapsed]="activeSection !== footerSections.SERVICES">
                <ng-container *ngTemplateOutlet="servicesTemplate"></ng-container>
              </div>
            </ng-container>
            <ng-container>
              <div class="flex flex-row items-center justify-between cursor-pointer py-3"
                (click)="toggleSection(footerSections.COMPANY)">
                <span>Company</span>
                <i-tabler
                  [name]="activeSection === footerSections.COMPANY ? 'chevron-up' : 'chevron-down'"
                  class="text-white-60">
                </i-tabler>
              </div>
              <div class="pt-2 accordion-content"
                [class.expanded]="activeSection === footerSections.COMPANY"
                [class.collapsed]="activeSection !== footerSections.COMPANY">
                <ng-container *ngTemplateOutlet="companyTemplate"></ng-container>
              </div>
            </ng-container>
            <ng-container>
              <div class="flex flex-row items-center justify-between cursor-pointer py-3"
                (click)="toggleSection(footerSections.GET_IN_TOUCH)">
                <span>Get in Touch</span>
                <i-tabler
                  [name]="activeSection === footerSections.GET_IN_TOUCH ? 'chevron-up' : 'chevron-down'"
                  class="text-white-60">
                </i-tabler>
              </div>
              <div class="pt-2 accordion-content"
                [class.expanded]="activeSection === footerSections.GET_IN_TOUCH"
                [class.collapsed]="activeSection !== footerSections.GET_IN_TOUCH">
                <ng-container *ngTemplateOutlet="getInTouchTemplate"></ng-container>
              </div>
            </ng-container>
          }
        </div>
        <div
          class="policy-section pt-[30px] flex flex-col gap-8 lg:gap-0 lg:flex-row text-white-80 items-center justify-between text-xs">
          <span class="order-2 lg:order-1">© {{ currentYear }} XrossOverSports. All rights reserved.</span>
          <div class="text-center order-1 lg:order-2">
            @for (link of legalLinks; track link; let isLast = $last) {
              <a [routerLink]="link.route">
                {{ link.title }} @if (!isLast) {
                <span class="text-white-20 mx-1">•</span>
              }
            </a>
          }
        </div>
      </div>
    </div>
  </div>
</div>
</div>

<ng-template #servicesTemplate>
  <div class="flex flex-col gap-[20px]">
    @if (!isSmallScreen) {
      <span class="font-semibold">Services</span>
    }
    @for (link of servicesLinks; track link) {
      <a class="footer-link text-white-80 text-sm" [routerLink]="link.route">{{
      link.title }}</a>
    }
  </div>
</ng-template>

<ng-template #companyTemplate>
  <div class="flex flex-col gap-[20px]">
    @if (!isSmallScreen) {
      <span class="font-semibold">Company</span>
    }
    @for (link of companyLinks; track link) {
      <a class="footer-link text-white-80 text-sm" [routerLink]="link.route">{{
      link.title }}</a>
    }
  </div>
</ng-template>

<ng-template #getInTouchTemplate>
  <div class="flex flex-col gap-[20px]">
    @if (!isSmallScreen) {
      <span class="font-semibold">Get in Touch</span>
    }
    <div class="flex flex-row items-center">
      <i-tabler name="arrow-up-right" class="text-primary-100 mr-3 flex-shrink-0"></i-tabler>
      <span class="flex-grow  text-white-80 text-sm">
        XrossOver Sports Training <br>902 W. 8th St.Houston, TX 77007
      </span>
    </div>
    <div class="flex flex-row items-center">
      <i-tabler name="arrow-up-right" class="text-primary-100 mr-3 flex-shrink-0"></i-tabler>
      <span class="flex-grow  text-white-80 text-sm">
        support&#64;xrossoversports.com
      </span>
    </div>
    <div class="flex flex-row items-center">
      <i-tabler name="arrow-up-right" class="text-primary-100 mr-3 flex-shrink-0"></i-tabler>
      <span class="flex-grow  text-white-80 text-sm">
        281-865-9348
      </span>
    </div>

    <div class="mt-5 gap-[10px] flex flex-row justify-center lg:justify-start">
      @for (link of getInTouchLinks; track link) {
        <a
          class="social-link flex flex-col items-center flex-shrink-0 justify-center" [href]="link.route"
          target="_blank">
          <i-tabler [name]="link.icon" class="text-white-100"></i-tabler>
        </a>
      }
    </div>
  </div>
</ng-template>